<script>
import tableSearch from "@/mixins/tableSearch";
import CommonTableComponent from "@/components/table.vue";
import apiEndpoints from "@/services/apiEndpoints";
import SearchDataWasteCategoryModal from '@/components/InputSearchModal/SearchDataWasteCategoryModal.vue'
import SearchDataVendorSiteModal from "@/components/InputSearchModal/SearchDataVendorSiteModal";
import SearchDataWorkOrderModal from "@/components/InputSearchModal/SearchDataWorkOrderModal.vue";

export default {
  components: {
    SearchDataWorkOrderModal,
    SearchDataVendorSiteModal,
    CommonTableComponent,
    SearchDataWasteCategoryModal
  },
  mixins: [tableSearch],
  props: {
    dailyReport: {
      type: Object,
      required: true,
    }
  },
  data() {
    return {
      isLoading: false,
      header: [
        {
          text: "選択",
        },
        {
          text: "廃棄物・サービス名",
          value: "waste_or_service_name",
          sortable: true
        },
        {
          text: "廃棄物種類",
          value: "waste_category_of_treatment_name_abbreviated",
          sortable: true
        },
        {
          text: "運搬先",
          value: "vendor_site_name_abbreviated",
          sortable: true
        },
        {
          text: "処分方法",
          value: "treatment_method",
          sortable: true
        },
      ],
      dataSelected: [],
      wastesOrServicesByWorkOrder: [],
      filters: {
        waste_category_of_treatment_name_abbreviated: "",
        vendor_site_name_abbreviated: "",
      }
    }
  },
  methods: {
    async getData() {
      const workOrderId = this.dailyReport.schedule?.work_reservation?.work_order_id;
      if (!workOrderId) {
        return;
      }
      this.isLoading = true;
      const url = apiEndpoints.wastes_or_services_by_work_order_id(workOrderId);
      const {status, data} = await this.$http.get(url, this.filters);

      if (status && data.result) {
        this.wastesOrServicesByWorkOrder = data.result;
      }
      this.isLoading = false;
    },
    search() {
      this.getData();
    },
    updateValue: function () {
      this.$emit("dataSelected", this.dataSelected);
      this.$bvModal.hide('select-waste-or-service-by-work-order')
    },
    handleCheckBoxDisable(wasteOrService) {
      return this.dataSelected.length > 0 && !this.dataSelected.includes(wasteOrService.id)
    },
    saveSelectWasteOrServices() {
      this.updateValue()
    },
    onSelectData(data) {
      this.filters = data;
    },
    clearDataSearch() {
      this.filters = {
        waste_category_of_treatment_name_abbreviated: "",
        vendor_site_name_abbreviated: "",
      }
      this.search()
    },
    hideSelectWasteOrServiceModal() {
      this.$bvModal.hide('select-waste-or-service-by-work-order')
    },
    onClickRow(row) {
      if (!this.dataSelected.includes(row.id) && !this.dataSelected.length) {
        this.dataSelected.push(row.id)
      } else {
        const index = this.dataSelected.indexOf(row.id)
        if (index > -1) {
          this.dataSelected.splice(index, 1)
        }
      }
    },
    getName(row) {
      if (row.waste) {
        return row.waste?.name
      }

      return row.service?.name
    },
    getWasteCategoryName(row) {
      if (!row.waste) return '';

      return row.disposal_site?.disposal_site_by_waste_category?.waste_category_of_treatment?.name_abbreviated
    },
    getVendorSiteName(row) {
      if (!row.waste) return '';

      return row.disposal_site?.disposal_site_by_waste_category?.vendor_site_of_treatment?.name_abbreviated
    },
    getTreatmentMethod(row) {
      if (!row.waste) return '';

      return row.disposal_site?.disposal_site_by_waste_category?.zz_treatment_method?.treatment_method
    },
  },
  computed: {
  },
}
</script>
<template>
  <div class="mb-2 d-xl-flex">
    <button
      v-b-modal.select-waste-or-service-by-work-order
      class="btn btn-primary w-100 waves-effect waves-light"
    >
      廃棄物・サービスを選択する
    </button>
    <!-- modal area -->
    <b-modal
      size="xl"
      id="select-waste-or-service-by-work-order"
      centered
      title-class="font-18"
      title="作業別廃棄物・サービス一覧"
      hide-footer
      scrollable
      @show="getData"
    >
      <b-row class="mt-2">
        <b-overlay
          :show="isLoading"
          rounded
          opacity="0.6"
          spinner-small
          spinner-variant="primary"
          class="d-inline-block"
        >
          <div class="waste-or-service">
            <b-row>
              <b-col cols="6">
                <SearchDataWasteCategoryModal :dataSearch="filters" @dataSelected="onSelectData"/>
              </b-col>
              <b-col offset="1" cols="5">
                <SearchDataVendorSiteModal :dataSearch="filters" @dataSelected="onSelectData"/>
              </b-col>
            </b-row>
            <b-row class="my-4">
              <div class="d-flex justify-content-center align-items-center">
                <b-button size="lg" variant="primary" @click="search" class="me-2">
                  <div class="d-flex align-items-center justify-content-center">
                    <i class="fas fa-search"></i> {{ this.$lang.button.search }}
                  </div>
                </b-button>
                <b-button @click="clearDataSearch" variant="dark" size="lg">
                  <i class="fas fa-eraser"></i> {{ this.$lang.button.clear }}
                </b-button>
              </div>
            </b-row>
            <div class="my-2">※作業分類を1つ選択し、その中で複数の廃棄物・サービスの依頼が必要であればチェック願います。</div>
            <CommonTableComponent :height-class="`table-wrapper-500`">
              <thead class="table-light">
              <tr class="text-center align-middle">
                <th
                  v-for="(item, index) in header"
                  :key="index"
                  :class="getHeaderClass(item)"
                >
                  <span v-html="item.text"> </span>
                </th>
              </tr>
              </thead>
              <tbody>

              <tr v-for="(wasteOrService, index) in wastesOrServicesByWorkOrder" @click="onClickRow(wasteOrService)">
                <td class="text-center">
                  <b-form-checkbox
                    v-model="dataSelected"
                    :disabled="handleCheckBoxDisable(wasteOrService)"
                    :value="wasteOrService.id"
                  ></b-form-checkbox>
                </td>
                <td>{{ getName(wasteOrService)}}</td>
                <td>{{ getWasteCategoryName(wasteOrService) }}</td>
                <td>{{ getVendorSiteName(wasteOrService) }}</td>
                <td>{{ getTreatmentMethod(wasteOrService) }}</td>
              </tr>
              <tr v-if="!wastesOrServicesByWorkOrder.length && !isLoading">
                <td :colspan="header.length" class="text-center">
                  データなし。
                </td>
              </tr>
              </tbody>
            </CommonTableComponent>
          </div>
          <div class="d-flex justify-content-end mt-2">
            <button
              class="btn btn-primary waves-effect waves-light me-2 btn-lg"
              :disabled="!dataSelected.length"
              @click="saveSelectWasteOrServices"
            >
              <i class='fas fa-check'></i> 確定
            </button>
            <button
              class="btn btn-primary waves-effect waves-light btn-lg"
              @click="hideSelectWasteOrServiceModal"
            >
              <i class='far fa-arrow-alt-circle-left'></i> {{ this.$lang.button.back }}
            </button>
          </div>
        </b-overlay>
      </b-row>
    </b-modal>
  </div>
</template>
<style scoped>
</style>
